import { ETheme } from "@/dependencies";
import { webDarkTheme, webLightTheme } from "@fluentui/react-components";

export const buildColorByThemeFluentUI = (theme: ETheme, color: string): string => {
  if (theme === ETheme.Dark) {
    return webDarkTheme[color as keyof typeof webDarkTheme] as string || color;
  }
  return webLightTheme[color as keyof typeof webLightTheme] as string || color;
};

export const buildColorByThemeForColor = (theme: ETheme, colorLight: string, colorDark: string): string => {
  if (theme === ETheme.Dark) {
    return colorDark;
  }
  return colorLight;
};

